export default __webpack_public_path__ + "static/media/InsuranceCard.a3becbac.png";